// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3M_kK"};